import App from './App.svelte';
const app = new App({
    target: document.body,
    props: {
        boardSize: 15,
    }
});
export default app;
